import { getAuthToken } from '@/auth';
import { getApiV1UsersUserIdCarouselsRecentDownloads } from '@/open-api/users/users';

import type { RecentDownloadTile } from '@/open-api/model';
import type {
  RecentDownloadsCarousel,
  RecentDownloadsTile,
} from '@/types/carousel';

const MAX_TILES = 10;

export const mapRecentDownloadTile = (
  tile: NonNullable<RecentDownloadTile>,
  index: number
): RecentDownloadsTile => ({
  id: index,
  order: index,
  slug: '',
  tile_image_main: tile.artistImage ?? '',
  tile_image_left: tile.similarArtist1Image ?? '',
  tile_image_right: tile.similarArtist2Image ?? '',
  main_track_artist: tile.artistName ?? '',
  main_track_name: tile.trackName,
  main_track_energy: tile.trackEnergy,
  main_track_id: tile.trackId,
  url: `/music/similar/${tile.artistSlug ?? ''}/${tile.trackSlug ?? ''}`,
});

export const getRecentDownloadsCarousels = async (
  userId?: number
): Promise<RecentDownloadsCarousel[]> => {
  // Signed-out visitors have no downloads, so don't ask the API (it would 401).
  if (!(userId && getAuthToken())) {
    return [];
  }

  let tiles: RecentDownloadTile[];

  try {
    const data = await getApiV1UsersUserIdCarouselsRecentDownloads(userId, {
      Limit: MAX_TILES,
    });
    tiles = data?.tiles ?? [];
  } catch (err) {
    console.error(err);

    return [];
  }

  return [
    {
      name: 'Based on your downloads',
      order: 1,
      tiles: tiles
        .filter(
          (tile): tile is NonNullable<RecentDownloadTile> => tile !== null
        )
        .map(mapRecentDownloadTile),
    },
  ];
};
